import { NmsWizardStepModel } from "@nms-angular-toolkit/nms-wizard";
import { Device } from "@nms-ng2/app/modules/device/device-backup/device-backup.models";
import { MuxDemuxData } from "../1-ends/end-step-circuit-dwdm.model";

/**
 * Representa o modelo do step Transponders do DwdmCircuitWizard.
 */
export class TranspondersStepModel extends NmsWizardStepModel {
    circuitId?: number
    aEndDevice: Device;
    zEndDevice: Device;
    aEndPorts: Array<TransponderPort>;
    zEndPorts: Array<TransponderPort>;
    hasTxPowerChanges: boolean = false;

    constructor() {
        super();
        this.aEndDevice = {} as Device;
        this.zEndDevice = {} as Device;
        this.aEndPorts = [];
        this.zEndPorts = [];
    }
}

/**
 * Representa a porta utilizada no step Transponders.
 */
export class TransponderPort {
    portNo: string;
    portModel: string;
    portName: string;
    channel: string;
    multirate: string;
    txPower: number;

    constructor(portNo: string, portModel: string, portName: string, txPower: number = 0, multirate?: string) {
        this.portNo = portNo;
        this.portModel = portModel;
        this.portName = portName;
        this.txPower = txPower;
        this.multirate = multirate;
    }
}

/**
 * Representa o canal de comunicação da porta utilizada no step Transponders.
 */
export interface ChannelData {
    channel: number;
    frequency: number;
    waveLength: number;
}

/**
 * Representa as configurações dos limites de operação padrão da potência de transmissão das portas.
 */
export interface TxPowerSettingsData {
    minValue: number;
    maxValue: number;
    unit: string;
}

/**
 * Representa os tamanhos de grade de frequência dos canais em redes ópticas.
 */
export enum GridSize {
    GRID_50GHZ = "GRID_50GHZ",
    GRID_100GHZ = "GRID_100GHZ"
}

/**
 * Modelo que representa os transponders configurados na tela de Circuitos DWDM e que
 * serão utilizados na validação.
 */
export interface TranspondersData {
    circuitId: number;
    aEndDevice: Device
    aEndUseMuxDemux: boolean
    aEndMuxDemux: MuxDemuxData;
    zEndDevice: Device;
    zEndUseMuxDemux: boolean;
    zEndMuxDemux: MuxDemuxData;
    aEndPorts: TransponderPortData[];
    zEndPorts: TransponderPortData[];
}

/**
 * Modelo que representa as portas utilizadas pelos transponders, as quais serão utilizadas
 * na validação do circuito DWDM.
 */
export interface TransponderPortData {
    portNo: string;
    portModel: string;
    portName: string;
    channel: string;
    multirate: string;
    txPower: string;
    frequency?: string;
    waveLength?: string;
}
